export default __webpack_public_path__ + "static/media/404.e7f437c0.jpg";